import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { UpdateWorkflowTemplateForm } from '../forms/UpdateWorkflowTemplateForm';

type UpdateWorkflowTemplateModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  workflowTemplateId: string;
  defaultData: {
    name: string;
    description?: string;
    externalName?: string;
    key?: string;
  };
};

export const UpdateWorkflowTemplateModal = ({
  isOpen,
  onClose,
  onSuccess,
  workflowTemplateId,
  defaultData,
}: UpdateWorkflowTemplateModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Update Workflow Template</DialogTitle>
        </DialogHeader>
        <UpdateWorkflowTemplateForm
          onSuccess={onSuccess}
          onCancel={onClose}
          formContentClassName="p-6"
          formFooterClassName="p-6"
          workflowTemplateId={workflowTemplateId}
          defaultData={defaultData}
        />
      </DialogContent>
    </Dialog>
  );
};
